import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import type {
  TGetCompanyUBODocumentParams,
  TGetCompanyUBODocumentResponse,
} from "./getCompanyUBODocument.schema";

export const getCompanyUBODocument = (axios: IAxiosInstance) => {
  return async (
    params: TGetCompanyUBODocumentParams
  ): Promise<TGetCompanyUBODocumentResponse> => {
    const { companyID, first_name, last_name } = params;
    const response = await axios.noRetry.get<
      IApiResponse<TGetCompanyUBODocumentResponse>
    >(`/api/companies/${companyID}/ubo-document`, {
      params: { first_name, last_name },
    });
    const resData = response.data;
    if (resData?.success && resData.data) {
      return resData.data;
    }
    throw new Error("Something went wrong");
  };
};
